import { Params } from '@angular/router';

/** Trade statuses Telebirr sends on browser return / notify that mean payment succeeded or is finalizing. */
export function isTelebirrPaidTradeStatus(tradeStatus: string): boolean {
  if (!tradeStatus) {
    return false;
  }
  const s = tradeStatus.trim().toUpperCase();
  return s === 'PAY_SUCCESS'
    || s === 'COMPLETED'
    || s === 'TRADE_SUCCESS'
    || s === 'SUCCESS'
    || s === 'PENDING';
}

/** Build notify/callback payload from Telebirr redirect query string, or null when not a paid return. */
export function extractTelebirrNotifyFields(params: Params): Record<string, string> | null {
  const billRef = params['merch_order_id'];
  const tradeStatus = params['trade_status'];
  if (!billRef || !isTelebirrPaidTradeStatus(tradeStatus)) {
    return null;
  }

  const notifyFields: Record<string, string> = {};
  Object.keys(params).forEach(key => {
    const value = params[key];
    if (value != null && value !== '') {
      notifyFields[key] = value;
    }
  });
  return notifyFields;
}

export function isTelebirrCallbackSuccess(
  result: { code?: string; msg?: string; applicationId?: number; ApplicationId?: number } | null
): boolean {
  if (!result || result.code !== '0') {
    return false;
  }
  if (result.msg === 'success') {
    return true;
  }
  const id = result.applicationId ?? result.ApplicationId;
  return result.msg === 'ignored' && id != null && id > 0;
}
